var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountVouchersIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 18.9479V16.8716H1V18.9539C2.10203 19.0118 2.97847 19.9202 2.97847 21.0382C2.97847 22.1562 2.10203 23.0626 1 23.1205V25.7578C2.10203 25.8157 2.97847 26.724 2.97847 27.8401C2.97847 28.9561 2.10203 29.8664 1 29.9243V31.813H29V29.9303C27.8461 29.9303 26.9117 28.996 26.9117 27.8421C26.9117 26.6881 27.8461 25.7538 29 25.7538V23.1285C27.8461 23.1285 26.9117 22.1941 26.9117 21.0402C26.9117 19.8863 27.8461 18.9519 29 18.9519V18.9479Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30469 18.3411V16.7759",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30469 21.685V20.1198",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30469 25.0291V23.4619",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30469 28.3712V26.806",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30469 31.7152V30.15",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7601 16.7758L17.2728 1L15.6298 2.09205C16.1628 2.99244 15.9053 4.16036 15.0229 4.74531C14.1404 5.33027 12.9645 5.11665 12.3416 4.27815L10.2614 5.66168C10.7944 6.56207 10.5369 7.72998 9.65444 8.31494C8.77201 8.89989 7.59611 8.68627 6.97323 7.84777L5.48389 8.838L10.7625 16.7758",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2933 6.71778L20.5291 5.89725",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6541 8.47265L17.8898 7.65012",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0167 10.2255L15.2505 9.40497",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3776 11.9804L12.6134 11.1599",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74011 13.7333L9.97391 12.9128",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2978 25.2067C21.2978 24.3864 20.6332 23.7214 19.8135 23.7214C18.9937 23.7214 18.3291 24.3864 18.3291 25.2067V26.2229C18.3291 27.0432 18.9937 27.7083 19.8135 27.7083C20.6332 27.7083 21.2978 27.0432 21.2978 26.2229V25.2067Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.674 22.2679C16.674 21.4476 16.0095 20.7826 15.1897 20.7826C14.3699 20.7826 13.7053 21.4476 13.7053 22.2679V23.2841C13.7053 24.1045 14.3699 24.7695 15.1897 24.7695C16.0095 24.7695 16.674 24.1045 16.674 23.2841V22.2679Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.475 20.5131L15.5281 27.9778",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountVouchersIconWhite);
export default __webpack_public_path__ + "static/media/DiscountVouchersIconWhite.16111b5e62baa282518a01670c6fde98.svg";
export { ForwardRef as ReactComponent };